import { useState, useEffect } from 'react';
import './App.css';
import './theme/tailwind.css';
import { b2cPolicies } from './utils/auth/authConfig';
import { compareIssuingPolicy } from './utils/auth/claimUtils';
import { Route, Routes } from 'react-router-dom';
import { MsalProvider, useMsal } from '@azure/msal-react';
import { EventType } from '@azure/msal-browser';
import  Home  from './pages/Home';
import  ReportHomePage  from './pages/report/pages/Home';
import  ReportPage  from './pages/report/pages/Report';
import  PageNotFound  from './pages/report/ui/PageNotFound';
import  AppOwnsDataPage  from './pages/report';
import { useDispatch, Provider } from 'react-redux';
import { setAccessToken } from './utils/redux/reducers/tokenReducer';
import store from './utils/redux/store';
import OfflinePage from './pages/OfflinePage';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify';
import OfflineToast from './components/toast/offline';
import OnlineToast from './components/toast/online';
import { ConnectionProvider } from './utils/helper/ConnectionContext';
import { saveAuthToken } from './utils/services/idbService';
import ConfirmationPopUp from "./components/popups/ConfirmationPopup";
import { useOfflineSwitch } from "utils/helper/OfflineSwitchContext";




const Pages = () => {
    const { instance } = useMsal();
    const dispatch = useDispatch(); // Get the dispatch function

    const [isOnline, setIsOnline] = useState(navigator.onLine);  // Moved to top level

    useEffect(() => {
        // This function is triggered when the online/offline status changes
        const updateOnlineStatus = () => {
            setIsOnline(navigator.onLine);
            if (!navigator.onLine) {
                toast(<OfflineToast />, {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    className: 'toast-background-color-offline'
                });
            } else{
              toast(<OnlineToast />, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                className: 'toast-background-color-online'
            });
            }
        };

        window.addEventListener('online', updateOnlineStatus);
        window.addEventListener('offline', updateOnlineStatus);

        // Cleanup the event listeners when the component is unmounted
        return () => {
            window.removeEventListener('online', updateOnlineStatus);
            window.removeEventListener('offline', updateOnlineStatus);
        };
    }, [isOnline]);

    useEffect(() => {
        async function getTokenAndInitialize() {
            const storedToken = localStorage.getItem('auth_token'); // or localStorage.getItem()

            if (storedToken) {
                // Optionally, verify the token's validity
                dispatch(setAccessToken(storedToken));

                // Also, load user data from IndexedDB into your app state
                localStorage.getItem('user_data');

            }
        }

        getTokenAndInitialize();
        const callbackId = instance.addEventCallback((event) => {
            if (
                (event.eventType === EventType.LOGIN_SUCCESS || event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) &&
                event.payload.account
            ) {
                if (event.payload.idTokenClaims['tfp'] === b2cPolicies.names.editProfile) {
                    const originalSignInAccount = instance
                        .getAllAccounts()
                        .find(
                            (account) =>
                                account.idTokenClaims.oid === event.payload.idTokenClaims.oid &&
                                account.idTokenClaims.sub === event.payload.idTokenClaims.sub &&
                                account.idTokenClaims['tfp'] === b2cPolicies.names.signUpSignIn
                        );

                    let signUpSignInFlowRequest = {
                        authority: b2cPolicies.authorities.signUpSignIn.authority,
                        account: originalSignInAccount,
                    };

                    instance.ssoSilent(signUpSignInFlowRequest);
                }

                if (compareIssuingPolicy(event.payload.idTokenClaims, b2cPolicies.names.forgotPassword)) {
                    let signUpSignInFlowRequest = {
                        authority: b2cPolicies.authorities.signUpSignIn.authority,
                    };
                    instance.loginRedirect(signUpSignInFlowRequest);
                }

                // Store the access token in Redux
                const accessToken = event.payload.accessToken;
                dispatch(setAccessToken(accessToken));
                localStorage.setItem('auth_token', accessToken);
                saveAuthToken(accessToken);
            }

            if (event.eventType === EventType.LOGIN_FAILURE) {
                if (event.error?.errorMessage.includes('AADB2C90118')) {
                    const resetPasswordRequest = {
                        authority: b2cPolicies.authorities.forgotPassword.authority,
                        scopes: [],
                    };
                    instance.loginRedirect(resetPasswordRequest);
                }
            }
        });

        return () => {
            if (callbackId) {
                instance.removeEventCallback(callbackId);
            }
        };
        // eslint-disable-next-line
    }, [instance, dispatch,]);

    return (
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/reports" element={<AppOwnsDataPage />}>
          <Route path="" element={<ReportHomePage />} />
          <Route path=":id" element={<ReportPage />} />
          <Route path="*" element={<PageNotFound />} />
        </Route>
      </Routes>
    );
};
const PagesOffline = () => {
    const { instance } = useMsal();
    const dispatch = useDispatch(); // Get the dispatch function

    const [isOnline, setIsOnline] = useState(navigator.onLine);  // Moved to top level

    useEffect(() => {
        // This function is triggered when the online/offline status changes
        const updateOnlineStatus = () => {
            setIsOnline(navigator.onLine);
            if (!navigator.onLine) {
                toast(<OfflineToast />, {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    className: 'toast-background-color-offline'
                });
            } else{
              toast(<OnlineToast />, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                className: 'toast-background-color-online'
            });
            }
        };

        window.addEventListener('online', updateOnlineStatus);
        window.addEventListener('offline', updateOnlineStatus);

        // Cleanup the event listeners when the component is unmounted
        return () => {
            window.removeEventListener('online', updateOnlineStatus);
            window.removeEventListener('offline', updateOnlineStatus);
        };
    }, [isOnline]);

    useEffect(() => {
        async function getTokenAndInitialize() {
            const storedToken = localStorage.getItem('auth_token'); // or localStorage.getItem()

            if (storedToken) {
                // Optionally, verify the token's validity
                dispatch(setAccessToken(storedToken));

                // Also, load user data from IndexedDB into your app state
                localStorage.getItem('user_data');

            }
        }

        getTokenAndInitialize();
        const callbackId = instance.addEventCallback((event) => {
            if (
                (event.eventType === EventType.LOGIN_SUCCESS || event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) &&
                event.payload.account
            ) {
                if (event.payload.idTokenClaims['tfp'] === b2cPolicies.names.editProfile) {
                    const originalSignInAccount = instance
                        .getAllAccounts()
                        .find(
                            (account) =>
                                account.idTokenClaims.oid === event.payload.idTokenClaims.oid &&
                                account.idTokenClaims.sub === event.payload.idTokenClaims.sub &&
                                account.idTokenClaims['tfp'] === b2cPolicies.names.signUpSignIn
                        );

                    let signUpSignInFlowRequest = {
                        authority: b2cPolicies.authorities.signUpSignIn.authority,
                        account: originalSignInAccount,
                    };

                    instance.ssoSilent(signUpSignInFlowRequest);
                }

                if (compareIssuingPolicy(event.payload.idTokenClaims, b2cPolicies.names.forgotPassword)) {
                    let signUpSignInFlowRequest = {
                        authority: b2cPolicies.authorities.signUpSignIn.authority,
                    };
                    instance.loginRedirect(signUpSignInFlowRequest);
                }

                // Store the access token in Redux
                const accessToken = event.payload.accessToken;
                dispatch(setAccessToken(accessToken));
                localStorage.setItem('auth_token', accessToken);
                saveAuthToken(accessToken);
            }

            if (event.eventType === EventType.LOGIN_FAILURE) {
                if (event.error?.errorMessage.includes('AADB2C90118')) {
                    const resetPasswordRequest = {
                        authority: b2cPolicies.authorities.forgotPassword.authority,
                        scopes: [],
                    };
                    instance.loginRedirect(resetPasswordRequest);
                }
            }
        });

        return () => {
            if (callbackId) {
                instance.removeEventCallback(callbackId);
            }
        };
        // eslint-disable-next-line
    }, [instance, dispatch, isOnline]);

    return (
        <OfflinePage />
    );
};

const App = ({ instance }) => {
    const isOffline = !navigator.onLine;
    const storedToken = localStorage.getItem('auth_token');

    const { offlineSwitchState } = useOfflineSwitch();
    const shouldRenderOffline = isOffline || !offlineSwitchState;

    // Wrap the common components in a function for reuse
    const CommonComponents = () => (
        <>
            <ToastContainer />
            <ConfirmationPopUp />
        </>
    );

    return (
        <div className="App">
            
            <ConnectionProvider>
                {shouldRenderOffline && storedToken ? (
                    <MsalProvider instance={instance}>
                    <Provider store={store}>
                        <PagesOffline />
                        <CommonComponents />
                    </Provider>
                    </MsalProvider>
                ) : (
                    <MsalProvider instance={instance}>
                        <Provider store={store}>
                            <Pages />
                            <CommonComponents />
                        </Provider>
                    </MsalProvider>
                )}
            </ConnectionProvider>
        </div>
    );
}

export default App;
